import React, { useState } from 'react';
import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import { MealItemType } from 'models/production-report.model';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { STORAGE_KEYS } from 'utils/constants';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  meal: MealItemType;
  refetchMeals: () => void;
};
const FinishMealProductionModal = ({ isOpen, onClose, meal, refetchMeals }: Props) => {
  const [loading, setLoading] = useState(false);
  const [quantity, setQuantity] = useState<number>();
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);

  const completeMealProduction = async () => {
    const data = {
      cokitchen_id: cokitchenId,
      kitchen_item_id: meal.kitchen_item_id,
      quantity
    };
    try {
      setLoading(true);
      const res = await apiService.post(`production-history/production/complete`, {
        data,
        useToken: true
      });
      if (res) {
        toast(<ToastMessage message='Meal production completed successfully' type='success' />);
      }
    } catch {
      toast(<ToastMessage message='An error occured' type='error' />);
    } finally {
      onClose();
      refetchMeals();
      setLoading(false);
    }
  };
  return (
    <LocalModal
      isOpen={isOpen}
      onRequestClose={onClose}
      title='Finish smokey jollof rice production'>
      <div className='w-full'>
        <div className='mt-6'>
          <div className='mb-6 relative'>
            <Input
              design='bordered'
              label='Portion produced'
              placeholder='50'
              name='quantity'
              type='tel'
              pattern='[0-9]*'
              value={quantity}
              onChange={(e) => setQuantity(+e.target.value)}
            />
            <p className='text-sm text-[#96999C] absolute top-[55%] right-4 z-50'>portion</p>
          </div>
          <div className='mt-4 flex justify-end w-full'>
            <Button
              variant='block'
              color='primary'
              className='w-[139px] h-[41px]'
              disabled={loading}
              onClick={completeMealProduction}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    </LocalModal>
  );
};

export default FinishMealProductionModal;
